type Tab = {
  id: string;
  label: string;
};

export const catalogTabsList: Tab[] = [
  { label: 'Asiakirjatilaukset', id: 'document_order_services' },
  { label: 'Asennuspalvelut', id: 'installation_services' },
  { label: 'Turvallisuuspalvelut', id: 'security_services' },
  { label: 'Mattopesu', id: 'carpet_cleaning_services' },
  { label: 'Muuttopalvelut', id: 'relocation_services' },
  { label: 'Siivouksen lisäpalvelut', id: 'additional_cleaning_services' },
  {
    label: 'Valvonta-ja kartoituspalvelut',
    id: 'monitoring_and_mapping_services',
  },
  { label: 'Siivouspalvelut', id: 'cleaning_services' },
  { label: 'Digi-talkkaripalvelut', id: 'digital_cleaning_services' },
];
